import { useState } from 'react'

import { Logo } from 'components/atoms/Logo'
import { ModalLink } from 'components/atoms/ModalLink'
import { smoothScrollTo } from 'lib/utils'
import { Sidebar } from 'components/organisms/Sidebar/Sidebar'

import type { HeaderProps } from './types'

import { EModalType } from 'components/organisms/modals/enums'

import './index.scss'
import {
  Button,
  EButtonStyleVariant,
  EButtonVariant,
} from 'components/atoms/Button'

const mainClass = 'header'

export const Header = ({ menu }: HeaderProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev)
  }

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <>
      <header className={mainClass} role="banner">
        <div className={`${mainClass}__wrap section`}>
          {menu && menu.length > 0 && (
            <Button
              className={`${mainClass}__burger`}
              onClick={handleToggleSidebar}
              variant={EButtonVariant.BUTTON}
              buttonVariant={EButtonStyleVariant.SPECIAL}
              aria-label="Toggle navigation menu"
            >
              <span className={`${mainClass}__burger-line`}></span>
              <span className={`${mainClass}__burger-line`}></span>
              <span className={`${mainClass}__burger-line`}></span>
            </Button>
          )}

          <a href="/" onClick={handleLogoClick}>
            <Logo />
          </a>

          {menu && menu.length > 0 && (
            <nav
              className={`${mainClass}__menu`}
              role="navigation"
              aria-label="Main navigation"
            >
              {menu.map((item) => (
                <a
                  key={item.href}
                  className={`${mainClass}__menu-item`}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault()
                    smoothScrollTo(item.href)
                  }}
                >
                  {item.text}
                </a>
              ))}
            </nav>
          )}

        </div>
      </header>

      <Sidebar
        menu={menu || []}
        isOpen={isSidebarOpen}
        onClose={handleToggleSidebar}
      />
    </>
  )
}
